import React, { useState, useEffect } from 'react'; 
import { Routes, Route, useNavigate, Link } from 'react-router-dom'; 
import { Authenticator, View, Image, Heading, Button, Flex, Text, Card } from '@aws-amplify/ui-react';
import { signOut as amplifySignOut, getCurrentUser } from 'aws-amplify/auth'; 
import { Hub } from 'aws-amplify/utils'; 
import { FaArrowRight, FaQuestionCircle } from 'react-icons/fa';

// IMPORTS DE ESTILOS
import '@aws-amplify/ui-react/styles.css';
import './App.css'; 

// IMPORTS DE TUS COMPONENTES
import Header from './components/Header'; 
import Footer from './components/Footer'; 
import LoginModal from './components/LoginModal'; 
import SignupModal from './components/SignupModal'; 
import FloatingButtons from './components/FloatingButtons'; 
import YoutubeSection from './components/YoutubeSection'; // Asegurando el import para la sección de abajo

// IMPORTS DE TUS PÁGINAS
import HomeContent from './pages/HomeContent'; 
import FileUploadPage from './pages/FileUploadPage';
import BookSalePage from './pages/ProductPage'; 
import BooksCatalog from './pages/BooksCatalog'; 
import ContactPage from './pages/ContactPage';
import AdminDashboard from './pages/AdminDashboard'; 
import ConsultsPage from './pages/ConsultsPage'; 
import ServicesPage from './pages/ServicesPage'; 
import CeoProfilePage from './pages/CeoProfilePage'; 
import AvaluosPage from './pages/AvaluosPage'; 
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'; 
import TeamPage from './pages/TeamPage';
import UserProfilePage from './pages/UserProfilePage'; 
import AyudaPage from './pages/AyudaPage'; // Import de la nueva página de ayuda

// SECCIÓN ACADEMIA
import CoursesCatalog from './pages/CoursesCatalog'; 
import CoursePage from './pages/CoursePage';       
import ReaderPage from './pages/ReaderPage'; 
import CoursePlayer from './pages/CoursePlayer'; 

// IMPORTS DE DETALLES
import DerechoMercantilPage from './pages/DerechoMercantilPage';
import DerechoCivilPage from './pages/DerechoCivilPage';
import ContabilidadFinanzasPage from './pages/ContabilidadFinanzasPage';
import Consultation1HourPage from './pages/Consultation1HourPage';
import ConsultationSpecialPage from './pages/ConsultationSpecialPage';
import Consultation30MinPage from './pages/Consultation30MinPage'; 

import logoImg from './logo.png'; 

const App = () => {
    const navigate = useNavigate(); 
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false); 
    const [isSignupModalOpen, setIsSignupModalOpen] = useState(false); 
    const [currentUser, setCurrentUser] = useState(null); // Estado para la campana global
    
    useEffect(() => {
        const checkUser = async () => {
            try {
                const user = await getCurrentUser();
                setCurrentUser(user);
            } catch {
                setCurrentUser(null);
            }
        };
        checkUser();

        const unsubscribe = Hub.listen('auth', ({ payload }) => {
            if (payload.event === 'signedIn') {
                checkUser();
            }
            if (payload.event === 'signedOut') {
                setIsLoginModalOpen(false);
                setIsSignupModalOpen(false);
                setCurrentUser(null);
                localStorage.clear();
                navigate("/", { replace: true }); 
            }
        });
        return () => unsubscribe(); 
    }, [navigate]);

    const ADMIN_EMAILS = [
        "javierantonioolivo@gmail.com",
        "gioscarvaci@gmail.com",
        "giovanni.scarvaci@gmail.com",
        "giovanniscarvaciyasociados@gmail.com"
    ];

    const adminAuthComponents = {
        Header() {
            return (
                <View textAlign="center" padding="20px">
                    <button 
                        onClick={() => navigate('/')} 
                        style={{
                            position: 'fixed', top: '20px', left: '20px', zIndex: 9999,
                            backgroundColor: '#D4AF37', color: 'black', border: 'none',
                            padding: '10px 20px', borderRadius: '5px', fontWeight: 'bold',
                            cursor: 'pointer', boxShadow: '0 4px 10px rgba(0,0,0,0.3)'
                        }}
                    >
                        ← Volver a la Web Principal
                    </button>
                    <Image alt="Logo" src={logoImg} style={{ height: '100px', marginBottom: '10px' }} />
                    <Heading level={4} color="#D4AF37">ACCESO ADMINISTRATIVO</Heading>
                </View>
            );
        },
        Footer() { return <View textAlign="center" padding="20px"><Text color="#666">Dr. Giovanni Scarvaci & Asociados © 2026</Text></View>; }
    };

    const handleLogout = async () => {
        try { await amplifySignOut(); } catch (error) { console.error('Error logout:', error); }
    };
    
    const handleSignupClick = () => { setIsLoginModalOpen(false); setIsSignupModalOpen(true); };
    const handleLoginClick = () => { setIsSignupModalOpen(false); setIsLoginModalOpen(true); };

    const PublicLayout = ({ children }) => (
        <>
            {/* Pasamos currentUser al Header para que la notificación funcione en toda la web */}
            <Header user={currentUser} onLoginClick={handleLoginClick} onLogoutClick={handleLogout} onSignupClick={handleSignupClick} />
            <main className="content">
                {children}
                
                {/* INYECCIÓN DEL BANNER DE AYUDA GLOBAL (Aparecerá en el fondo de todas las páginas públicas) */}
                {window.location.pathname === '/' || window.location.pathname === '/inicio' ? (
                    <>
                    <YoutubeSection />
                    <div style={{
                        background: 'linear-gradient(90deg, #1a1a1a 0%, #2c2c2c 100%)',
                        padding: '40px',
                        margin: '40px 20px',
                        borderRadius: '20px',
                        border: '2px solid #C5A059',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '20px',
                        boxShadow: '0px 10px 30px rgba(0,0,0,0.5)'
                    }}>
                        <div style={{ flex: '1', minWidth: '300px' }}>
                            <h2 style={{ color: '#C5A059', fontSize: '2rem', marginBottom: '10px' }}>
                                👴👵 ¿Necesita Ayuda con la Web?
                            </h2>
                            <p style={{ color: '#fff', fontSize: '1.2rem', lineHeight: '1.6' }}>
                                Hemos diseñado guías con <b>letras grandes y dibujos</b> para enseñarle a 
                                registrarse, comprar libros y ver sus cursos paso a paso.
                            </p>
                        </div>
                        
                        <Link to="/ayuda" style={{
                            backgroundColor: '#C5A059',
                            color: '#000',
                            padding: '15px 35px',
                            borderRadius: '50px',
                            fontSize: '1.3rem',
                            fontWeight: 'bold',
                            textDecoration: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            VER GUÍAS DE USO <FaArrowRight />
                        </Link>
                    </div>
                    </>
                ) : null}
            </main>
            <Footer />
            <FloatingButtons /> 
        </>
    );

    const AdminLayout = ({ children }) => (
        <View className="admin-layout">
            <main className="content">{children}</main>
            <FloatingButtons />
        </View>
    );

    return (
        <View className="App">
            <Routes>
                {/* RUTA ADMINISTRADOR PROTEGIDA */}
                <Route 
                    path="/admin" 
                    element={
                        <Authenticator components={adminAuthComponents} hideSignUp={true}>
                            {({ user }) => {
                                const userEmail = user?.signInDetails?.loginId?.toLowerCase();
                                if (!ADMIN_EMAILS.includes(userEmail)) {
                                    return (
                                        <Flex direction="column" alignItems="center" justifyContent="center" height="70vh">
                                            <Card padding="40px" textAlign="center" backgroundColor="white">
                                                <Heading level={4} color="red">Acceso Denegado</Heading>
                                                <Button onClick={amplifySignOut} variation="primary">Cerrar Sesión</Button>
                                            </Card>
                                        </Flex>
                                    );
                                }
                                return <AdminLayout><AdminDashboard user={user} signOut={handleLogout} /></AdminLayout>;
                            }}
                        </Authenticator>
                    } 
                />

                {/* RUTA PERFIL USUARIO */}
                <Route 
                    path="/profile" 
                    element={
                        <Authenticator>
                            {({ user }) => (
                                <PublicLayout>
                                    <UserProfilePage user={user} signOut={handleLogout} />
                                </PublicLayout>
                            )}
                        </Authenticator>
                    } 
                />

                {/* RUTA ACADEMIA PROTEGIDA: CoursePlayer */}
                <Route 
                    path="/course-player/:courseId" 
                    element={
                        <Authenticator>
                            {({ user }) => (
                                <PublicLayout>
                                    <CoursePlayer user={user} />
                                </PublicLayout>
                            )}
                        </Authenticator>
                    } 
                />

                {/* RUTA LECTOR PROTEGIDA */}
                <Route 
                    path="/reader/:orderId" 
                    element={
                        <Authenticator>
                            {({ user }) => (
                                <ReaderPage user={user} />
                            )}
                        </Authenticator>
                    } 
                />

                {/* RUTAS PÚBLICAS */}
                <Route path="/" element={<PublicLayout><HomeContent /></PublicLayout>} />
                <Route path="/inicio" element={<PublicLayout><HomeContent /></PublicLayout>} />
                <Route path="/ayuda" element={<PublicLayout><AyudaPage /></PublicLayout>} />
                <Route path="/contacto" element={<PublicLayout><ContactPage /></PublicLayout>} />
                <Route path="/quienes-somos" element={<PublicLayout><TeamPage /></PublicLayout>} />
                <Route path="/servicios" element={<PublicLayout><ServicesPage /></PublicLayout>} />
                <Route path="/politicas-de-privacidad" element={<PublicLayout><PrivacyPolicyPage /></PublicLayout>} />
                <Route path="/libros" element={<PublicLayout><BooksCatalog /></PublicLayout>} />
                <Route path="/book/:id" element={<PublicLayout><BookSalePage /></PublicLayout>} />
                <Route path="/cursos" element={<PublicLayout><CoursesCatalog /></PublicLayout>} />
                <Route path="/course/:id" element={<PublicLayout><CoursePage /></PublicLayout>} />
                <Route path="/servicios/derecho-mercantil" element={<PublicLayout><DerechoMercantilPage /></PublicLayout>} />
                <Route path="/servicios/contabilidad-finanzas" element={<PublicLayout><ContabilidadFinanzasPage /></PublicLayout>} />
                <Route path="/servicios/derecho-civil" element={<PublicLayout><DerechoCivilPage /></PublicLayout>} />
                <Route path="/servicios/avaluos" element={<PublicLayout><AvaluosPage /></PublicLayout>} />
                <Route path="/nuestro-ceo" element={<PublicLayout><CeoProfilePage /></PublicLayout>} /> 
                <Route path="/file-upload" element={<PublicLayout><FileUploadPage /></PublicLayout>} />
                <Route path="/consultas" element={<PublicLayout><ConsultsPage /></PublicLayout>} />
                <Route path="/consultas/30-minutos" element={<PublicLayout><Consultation30MinPage /></PublicLayout>} />
                <Route path="/consultas/1-hora" element={<PublicLayout><Consultation1HourPage /></PublicLayout>} />
                <Route path="/consultas/especial" element={<PublicLayout><ConsultationSpecialPage /></PublicLayout>} />
                
                {/* 404 */}
                <Route path="*" element={<PublicLayout><h1>404: Página no encontrada</h1></PublicLayout>} />
            </Routes>
            
            <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} onSignupSwitch={handleSignupClick} />
            <SignupModal isOpen={isSignupModalOpen} onClose={() => setIsSignupModalOpen(false)} onLoginSwitch={handleLoginClick} />
        </View>
    );
};

export default App;